import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseTabListProps = PropsWithChildren<{
  selectedTab: string;
}>;

export type TabListProps = AtomProps<BaseTabListProps, StyleClasses<"root">>;

export const TabList: React.FC<TabListProps> = ({
  id,
  selectedTab,
  className,
  classes,
  children,
  ...props
}): React.ReactElement => {
  const styles = useStyles(makeStyles);

  return (
    <div id={id} className={cx(styles.root, className, "no-scrollbar")} {...props}>
      {children}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    textWrap: "nowrap",
    overflowX: "auto",
    gap: theme.spacing(4),
  }),
});
